import { DataHelpers } from "../../../DataHelpers";
import { ConsultantDocument, ConsultantPeppolReceivedInvoice, ConsultantPeppolReceivedCreditNote, Consultant } from "../../../interfaces/Consultant";
import { Customer } from "../../../interfaces/Customer";
import { DataState, Invoice } from "../../../store/Data";

export interface ConsultantDocumentAgregator {
    date: Date;
    consultantDocument?: ConsultantDocument;
    consultantPeppolReceivedInvoice?: ConsultantPeppolReceivedInvoice;
    consultantPeppolReceivedCreditNote?: ConsultantPeppolReceivedCreditNote;
    invoice?: Invoice;
}

export function GetConsultantId(d: ConsultantDocumentAgregator) {
    if (d.consultantDocument) {
        return d.consultantDocument.consultantid;
    }
    else if (d.consultantPeppolReceivedInvoice) {
        return d.consultantPeppolReceivedInvoice.consultantid;
    }
    else if (d.consultantPeppolReceivedCreditNote) {
        return d.consultantPeppolReceivedCreditNote.consultantid;
    }
    else if (d.invoice) {
        return d.invoice.consultantid;
    }
    return null;
}
export function GetDocumentTypeId(d: ConsultantDocumentAgregator) {
    if (d.consultantDocument) {
        return d.consultantDocument.documentTypeId;
    }
    else if (d.consultantPeppolReceivedInvoice) {
        return 11;
    }
    else if (d.consultantPeppolReceivedCreditNote) {
        return 801;
    }
    else if (d.invoice) {
        if ( d.invoice.isCreditNote) {
            return 701;
        }
        return 1;
    }
    return 0;
}
export function GetSource(d: ConsultantDocumentAgregator, cs: Customer[] | undefined) {
    if (d.consultantDocument) {
        return d.consultantDocument.documentSource;
    }
    else if (d.consultantPeppolReceivedInvoice) {
        return d.consultantPeppolReceivedInvoice.registrationName;
    }
    else if (d.consultantPeppolReceivedCreditNote) {
        return d.consultantPeppolReceivedCreditNote.registrationName;
    }
    else if (d.invoice) {
        if (cs) {
            const c = cs.find(x => d.invoice && x.customerid === d.invoice.customerid);
            if (c) {
                return c.displayName;
            }
        }
        return d.invoice.customerid;
    }
    return null;
}
export function GetDescription(d: ConsultantDocumentAgregator) {
    if (d.consultantDocument) {
        return d.consultantDocument.description;
    }
    else if (d.consultantPeppolReceivedInvoice) {
        return d.consultantPeppolReceivedInvoice.description;
    }
    else if (d.consultantPeppolReceivedCreditNote) {
        return d.consultantPeppolReceivedCreditNote.description;
    }
    else if (d.invoice) {
        return d.invoice.description;
    }
    return null;
}
export function GetAmount(d: ConsultantDocumentAgregator, data: DataState, consultant: Consultant | undefined, customer: Customer | undefined) {
    if (d.consultantDocument) {
        return d.consultantDocument.documentAmount;
    }
    else if (d.consultantPeppolReceivedInvoice) {
        return d.consultantPeppolReceivedInvoice.taxInclusiveAmount;
    }
    else if (d.consultantPeppolReceivedCreditNote) {
        return d.consultantPeppolReceivedCreditNote.taxInclusiveAmount;
    }
    else if (d.invoice) {
        return DataHelpers.GetInvoiceTotalFromInvoice(data, consultant, customer, d.invoice);
    }
    return null;
}
export function GetLock(d: ConsultantDocumentAgregator) {
    if (d.consultantDocument) {
        return d.consultantDocument.lock;
    }
    else if (d.consultantPeppolReceivedInvoice) {
        return d.consultantPeppolReceivedInvoice.lock;
    }
    else if (d.consultantPeppolReceivedCreditNote) {
        return d.consultantPeppolReceivedCreditNote.lock;
    }
    else if (d.invoice) {
        return d.invoice.lock;
    }
    return true;
}
export function GetAccountingRef(d: ConsultantDocumentAgregator) {
    if (d.consultantDocument) {
        return d.consultantDocument.accountingRef;
    }
    else if (d.consultantPeppolReceivedInvoice) {
        return d.consultantPeppolReceivedInvoice.accountingRef;
    }
    else if (d.consultantPeppolReceivedCreditNote) {
        return d.consultantPeppolReceivedCreditNote.accountingRef;
    }
    else if (d.invoice) {
        return d.invoice.invoiceRef;
    }
    return null;
}
export function IsEditable(d: ConsultantDocumentAgregator): boolean {
    if (d.consultantDocument) {
        return d.consultantDocument.accountingRef === null && !d.consultantDocument.lock;
    }
    else if (d.consultantPeppolReceivedInvoice) {
        return d.consultantPeppolReceivedInvoice.accountingRef === null && !d.consultantPeppolReceivedInvoice.lock;
    }
    else if (d.consultantPeppolReceivedCreditNote) {
        return d.consultantPeppolReceivedCreditNote.accountingRef === null && !d.consultantPeppolReceivedCreditNote.lock;
    }
    else if (d.invoice) {
        return !d.invoice.lock;
    }
    return false;
}
export function IsPeppol(d: ConsultantDocumentAgregator) {
    if (d.consultantPeppolReceivedInvoice) {
        return true;
    }
    else if (d.consultantPeppolReceivedCreditNote) {
        return true;
    }
    else if (d.invoice) {
        return d.invoice.peppolSent;
    }
    return false;
}
export function PeppolStatus(d: ConsultantDocumentAgregator) {
    if (d.consultantPeppolReceivedInvoice) {
        return d.consultantPeppolReceivedInvoice.status;
    }
    return -1;
}
export function IsPeppolTest(d: ConsultantDocumentAgregator) {
    if (d.consultantPeppolReceivedInvoice) {
        return d.consultantPeppolReceivedInvoice.isTestDoc;
    }
    else if (d.consultantPeppolReceivedCreditNote) {
        return d.consultantPeppolReceivedCreditNote.isTestDoc;
    }
    return false;
}
